import React from 'react';

// This data is moved from in_process.js
const streamTextData = {
  Marketing: {
    fullText: `👍 Great work, you've been introduced to the following startups for interview!<br/><br/>
📩 All startup communication takes place over email. You'll be introduced to the startup's hiring lead by <strong>matchmaking@jumpstart</strong> – it's then on YOU to make the first move and arrange interviews.<br/><br/>
⏰ Don't delay! Be proactive and always respond within 24hrs. Startups notice.<br/><br/>
👩‍💻 Prepare thoroughly:<br/>
• <a href="https://jumpstart-alumni.notion.site/Preparing-for-Interviews-2025-127b8f57dd848085b669d676ad700244" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline hover:text-blue-800">study our carefully collated resources</a><br/>
• <a href="https://alumniplatformsupport.softr.app/" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline hover:text-blue-800">lean on alumni volunteers</a><br/>
• <a href="https://calendly.com/naim-jumpstart-uk/interview-coaching-generalist-marketing?month=2025-02" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline hover:text-blue-800">book time in our live interview support clinic</a><br/><br/>
This is all free to access and will 10x your interview skills.<br/><br/>
🏆 Go smash it! If you receive an offer or need any support throughout the process, simply drop <a href="mailto:info@jumpstart-uk.com" class="text-blue-600 underline hover:text-blue-800">info@jumpstart-uk.com</a> an email.`,
  },
  Generalist: {
    fullText: `👍 Great work, you've been introduced to the following startups for interview!<br/><br/>
📩 All startup communication takes place over email. You'll be introduced to the startup's hiring lead by <strong>matchmaking@jumpstart</strong> – it's then on YOU to make the first move and arrange interviews.<br/><br/>
⏰ Don't delay! Be proactive and always respond within 24hrs. Startups notice.<br/><br/>
👩‍💻 Prepare thoroughly:<br/>
• <a href="https://jumpstart-alumni.notion.site/Preparing-for-Interviews-2025-127b8f57dd848085b669d676ad700244" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline hover:text-blue-800">study our carefully collated resources</a><br/>
• <a href="https://alumniplatformsupport.softr.app/" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline hover:text-blue-800">lean on alumni volunteers</a><br/>
• <a href="https://calendly.com/naim-jumpstart-uk/interview-coaching-generalist-marketing?month=2025-02" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline hover:text-blue-800">book time in our live interview support clinic</a><br/><br/>
This is all free to access and will 10x your interview skills.<br/><br/>
🏆 Go smash it! If you receive an offer or need any support throughout the process, simply drop <a href="mailto:info@jumpstart-uk.com" class="text-blue-600 underline hover:text-blue-800">info@jumpstart-uk.com</a> an email.`,
  },
  Sales: {
    fullText: `👍 Great work, you've been introduced to the following startups for interview!<br/><br/>
📩 All startup communication takes place over email. You'll be introduced to the startup's hiring lead by <strong>matchmaking@jumpstart</strong> – it's then on YOU to make the first move and arrange interviews.<br/><br/>
⏰ Don't delay! Be proactive and always respond within 24hrs. Startups notice.<br/><br/>
👩‍💻 Prepare thoroughly:<br/>
• <a href="https://jumpstart-alumni.notion.site/Preparing-for-interviews-eb1da0ff850840c792133affab98a114?pvs=74" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline hover:text-blue-800">study our carefully collated resources</a><br/>
• <a href="https://alumniplatformsupport.softr.app/" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline hover:text-blue-800">lean on alumni volunteers</a><br/>
• <a href="https://calendly.com/d/ckht-n5w-p25/jumpstart-interview-prep-call" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline hover:text-blue-800">book time in our Wednesday interview support clinic</a><br/><br/>
This is all free to access and will 10x your interview skills.<br/><br/>
🏆 Go smash it! If you receive an offer or need any support throughout the process, simply drop <a href="mailto:info@jumpstart-uk.com" class="text-blue-600 underline hover:text-blue-800">info@jumpstart-uk.com</a> an email.`,
  },
  "Software Engineering": {
    fullText: `👍 Great work, you've been introduced to the following startups for interview!<br/><br/>
📩 All startup communication takes place over email. You'll be introduced to the startup's hiring lead by <strong>matchmaking@jumpstart</strong> – it's then on YOU to make the first move and arrange interviews.<br/><br/>
⏰ Don't delay! Be proactive and always respond within 24hrs. Startups notice.<br/><br/>
👩‍💻 Prepare thoroughly:<br/>
• <a href="https://jumpstart-alumni.notion.site/Preparing-for-Interviews-Software-Engineering-14db8f57dd8480959953ce8c3dc890ec?pvs=74" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline hover:text-blue-800">study our carefully collated resources</a><br/>
• <a href="https://calendly.com/kabir-7/catch-up-regarding-jumpstart" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline hover:text-blue-800">book a 1-1 interview practice session</a><br/><br/>
This is all free to access and will 10x your interview skills.<br/><br/>
🏆 Go smash it! If you receive an offer or need any support throughout the process, simply drop <a href="mailto:info@jumpstart-uk.com" class="text-blue-600 underline hover:text-blue-800">info@jumpstart-uk.com</a> an email.`,
  },
};

const keyPoints = [
  {
    icon: "👍",
    text: "You've been introduced to startups! Next steps are crucial."
  },
  {
    icon: "📩",
    text: "All communication is via email. You drive the interview scheduling."
  },
  {
    icon: "⏰",
    text: "Be proactive and respond to startups within 24 hours."
  }
];

const InterviewJourneyHeader = ({ stream, navigate }) => {

  const InfoBlock = ({ icon, title, subtitle, smallText = false }) => (
    <div className="flex items-start gap-3 md:items-center">
      <div className="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-[#02B491]/10 flex items-center justify-center mt-1 md:mt-0">
        <span className="text-base sm:text-lg">{icon}</span>
      </div>
      <div className='flex-grow'>
        <h3 className={`font-medium text-gray-800 ${smallText ? 'text-xs sm:text-sm' : 'text-sm sm:text-base'}`}>{title}</h3>
        {subtitle && <p className={`text-xs text-gray-600 ${smallText ? 'leading-tight' : ''}`}>{subtitle}</p>}
      </div>
    </div>
  );

  return (
    <div className="bg-white rounded-xl shadow-md p-4 sm:p-5 mb-8 border border-gray-100">
      <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-5">
        
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-5 flex-grow w-full">
          <InfoBlock 
            icon="⏰" 
            title="Respond within 24hrs"
            subtitle="Be proactive, startups notice!"
            smallText={true}
          />
          <InfoBlock 
            icon="📩" 
            title="Email is Key"
            subtitle="You arrange interviews after our intro."
            smallText={true}
          />
          <InfoBlock 
            icon="👩‍💻" 
            title="Prepare Thoroughly"
            subtitle="Use resources, alumni & clinics."
            smallText={true}
          />
        </div>

        <button
          onClick={() => navigate('/resources')}
          className="w-full md:w-auto mt-3 md:mt-0 flex-shrink-0 inline-flex items-center justify-center gap-2 px-4 py-2 bg-[#02B491] text-white rounded-lg hover:bg-[#029078] transition-colors text-xs sm:text-sm font-medium whitespace-nowrap shadow-sm hover:shadow-md focus:outline-none focus:ring-2 focus:ring-[#02B491]/50"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Full Interview Guide
        </button>
      </div>
    </div>
  );
};

export default InterviewJourneyHeader; 